// extracted by mini-css-extract-plugin
export default {"container":"telestration-canvas_container__XGSX1","canvas":"telestration-canvas_canvas__yKCAR"};